import { useQuery } from "@tanstack/react-query";
import { toast } from "react-toastify";

import OrganizationFunctionsService from "src/modules/data-protection/apis/OrganizationFunctionsService";
import { ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY } from "src/modules/data-protection/constants/organizationFunctions";

const extractFunctions = (payload) => {
    if (Array.isArray(payload?.functions)) {
        return payload.functions;
    }

    if (Array.isArray(payload?.data?.functions)) {
        return payload.data.functions;
    }

    if (Array.isArray(payload?.data)) {
        return payload.data;
    }

    return [];
};

const useOrganizationFunctions = (t) => {
    return useQuery({
        queryKey: ORGANIZATION_FUNCTIONS_LIST_QUERY_KEY,
        queryFn: async () => {
            const service = OrganizationFunctionsService.getInstance();
            const data = await service.list();

            return extractFunctions(data);
        },
        refetchOnWindowFocus: false,
        onError: (error) => {
            if (process.env.NODE_ENV === "development") {
                console.error(error);
            }

            toast(t("An error occurred while fetching functions."), {
                type: "error",
            });
        },
    });
};

export default useOrganizationFunctions;
